import http from '@/http/aisea/axios'
const resource = "/enterprises/admins/accounts";

export default {

  invites(enterpriseAccountId) {
    return http.post(`${resource}/${enterpriseAccountId}/password/invites`);
  },

};
